// A custom element also initializes after a theme-editor reload or an AJAX section replacement.
// Multiple copies of the snippet can load this asset without registering duplicate listeners.
if (!customElements.get('pim-attributes')) {
  customElements.define('pim-attributes', class extends HTMLElement {
    connectedCallback() {
      if (this.timer) return;
      this.variantIds = new Set((this.dataset.variantIds || '').split(','));
      this.lastVariant = this.dataset.currentVariantId || '';
      this.check = () => {
        const id = this.currentVariantId();
        if (id && id !== this.lastVariant) {
          this.lastVariant = id;
          this.apply(id);
        }
      };
      this.apply(this.lastVariant);
      this.check();
      this.timer = window.setInterval(this.check, 500);
      document.addEventListener('change', this.check);
      window.addEventListener('popstate', this.check);
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
      this.timer = null;
      document.removeEventListener('change', this.check);
      window.removeEventListener('popstate', this.check);
    }

    currentVariantId() {
      // Prefer this section. A recommended product's form must not control this table.
      const section = this.closest('.shopify-section');
      const scopes = section ? [section, document] : [document];
      for (const scope of scopes) {
        for (const input of scope.querySelectorAll('form[action*="/cart/add"] [name="id"]')) {
          if (this.variantIds.has(String(input.value))) return String(input.value);
        }
      }
      const fromUrl = new URL(window.location.href).searchParams.get('variant');
      return this.variantIds.has(fromUrl) ? fromUrl : this.lastVariant;
    }

    apply(id) {
      this.dataset.currentVariantId = id;
      this.querySelectorAll('[data-hin-pim-row]').forEach(row => {
        const spans = [...row.querySelectorAll('[data-variant-id]')];
        const variant = spans.find(span => span.dataset.variantId === id);
        const fallback = row.querySelector('[data-hin-pim-default]');
        spans.forEach(span => { span.hidden = span !== variant; });
        if (fallback) fallback.hidden = !!variant;
        row.hidden = !((variant || fallback)?.textContent.trim());
      });
      this.hidden = !this.querySelector('[data-hin-pim-row]:not([hidden])');
    }
  });
}
